import { Moment } from 'moment';

export class KeyCertificate {
  constructor(
    private readonly id: number,
    private readonly subject: string,
    private readonly issuer: string,
    private readonly digestAlgorithm: string | null,
    private readonly expiryDate: Moment | null
  ) {}

  getId() {
    return this.id;
  }

  getSubject() {
    return this.subject;
  }

  getIssuer() {
    return this.issuer;
  }

  getDigestAlgorithm() {
    return this.digestAlgorithm;
  }

  getExpiryDate() {
    return this.expiryDate;
  }
}
